(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prubo-slider"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
      new Swiper('.pruno‐swiper‐wrapper', {
        slidesPerView: 1.6,
        spaceBetween: 20,
        loop: false,
        pagination: {
          el: '.pruno‐swiper‐pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.pruno‐swiper‐next',
          prevEl: '.pruno‐swiper‐prev'
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40
          }
        }
      });
    });
  
  } catch(e) { console.error(e); }
})();
})();
